/**
 * VIVA HUB shell: sidebar + top bar + content
 */

import React, { useCallback, useState } from 'react'
import HubAppHeader from './HubAppHeader'
import HubSidebar from './HubSidebar'

export default function HubLayout({ children, appName }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const openSidebar = useCallback(() => setSidebarOpen(true), [])
  const closeSidebar = useCallback(() => setSidebarOpen(false), [])

  return (
    <div className="min-h-screen bg-background text-foreground">
      <HubSidebar open={sidebarOpen} onClose={closeSidebar} />

      <div className="flex min-h-screen flex-col lg:pl-72">
        <div className="sticky top-0 z-50 border-b border-border bg-card shadow-sm">
          <HubAppHeader
            appName={appName}
            withSidebar
            onOpenSidebar={openSidebar}
          />
        </div>

        <main className="w-full flex-1 px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
          <div className="mx-auto w-full max-w-7xl">{children}</div>
        </main>
      </div>
    </div>
  )
}
